<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-md-h5 font-weight-bold primary--text">
          <v-row>
            <v-col cols="12" sm="8">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>
              Gestionar Cupos
            </v-col>

            <v-col cols="12" sm="4">
              <div class="d-flex align-center">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  label="Buscar Cupo"
                  class="mr-4"
                  v-model="searchTable"
                >
                </v-text-field>

                <v-btn exact color="primary" @click="open"> Registrar </v-btn>
              </div>
            </v-col>

            <v-col cols="5" offset-sm="1" sm="2">
              <p class="text-subtitle-1 font-weight-bold primary--text">
                Total Cupos: {{ saberCompetencia.numero_participantes }}
              </p>
            </v-col>

            <v-col cols="5" sm="2">
              <p
                :class="[
                  'text-subtitle-1',
                  'font-weight-bold',
                  { 'error--text': cuposDisponibles == 0 },
                ]"
              >
                Disponibles: {{ cuposDisponibles }}
              </p>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 280px)"
          class="elevation-2"
          :headers="headersTable"
          :items="cuposSaber"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="mr-2"
                  @click="editarCupo(item.id_cupo)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="DialogEliminarCupo(item.id_cupo)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>

          <template v-slot:top>
            <v-dialog persistent max-width="520px" v-model="dialog">
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-form ref="form" v-model="form">
                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Competencia"
                            disabled
                            v-model="competencia"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Saber"
                            v-model="saber"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Modalidad"
                            v-model="modalidad"
                          ></v-text-field>

                          <v-select
                            outlined
                            dense
                            label="Regional"
                            :disabled="editedIndex === 1"
                            :items="regionales"
                            :rules="regionalReglas"
                            item-value="id"
                            item-text="regional"
                            v-model="regional"
                          ></v-select>

                          <v-select
                            outlined
                            dense
                            label="Centro de formación"
                            :disabled="editedIndex === 1"
                            :items="centrosFormacion"
                            :rules="centroFormacionReglas"
                            item-value="id"
                            item-text="centro_formacion"
                            v-model="centroFormacion"
                          ></v-select>

                          <v-text-field
                            outlined
                            dense
                            readonly
                            type="number"
                            label="Cupos disponibles"
                            v-model="cupoDisponible"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Número Participantes"
                            v-model="numeroParticipantes"
                            :rules="numeroParticipantesReglas"
                          ></v-text-field>

                          <v-text-field
                            outlined
                            dense
                            readonly
                            type="number"
                            label="Cantidad Grupos"
                            :value="cantidadGrupos"
                            :rules="cantidadGruposReglas"
                          ></v-text-field>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="close"> Cancelar </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn text exact color="primary" @click="registrar">
                      Registrar
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn text exact color="primary" @click="actualizar">
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card>

      <!-- alerta eliminar -->
      <v-dialog v-model="dialogDelete" max-width="480px">
        <v-card>
          <v-card-title class="justify-center text-h5"
            >¿Esta seguro de eliminar el cupo?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="closeDelete"> Cancelar </v-btn>
            <v-btn text color="error" @click="deleteItemConfirm"> OK </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    headersTable: [
      {
        text: "Saber",
        value: "saber",
        width: "35%",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Regional",
        value: "regional",
        align: "start",
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Centro de formación",
        value: "centro_formacion",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "# Participantes",
        value: "numero_participantes",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },
    ],

    dialog: false,
    dialogDelete: false,
    form: false,
    loadingForm: false,

    saberId: null,
    regional: null,
    modalidad: null,
    modalidadId: null,
    saber: null,
    competencia: null,
    centroFormacion: null,
    cupos: null,
    cupoId: null,

    cupoDisponible: null,

    numeroParticipantes: null,
    numeroParticipantesReglas: [
      (v) => !!v || "Escriba un número de participantes",
      (v) => !v || v > 0 || "El número debe ser mayor a 0",
    ],

    cantidadGruposReglas: [
      (v) => v > 0 || "El número de participantes no coincide con la modalidad",
    ],

    regionalReglas: [(v) => !!v || "Seleccione una regional"],
    centroFormacionReglas: [(v) => !!v || "Seleccione un centro de formación"],

    editedIndex: -1,
  }),

  components: {
    Alert,
  },

  mounted() {
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
    this.$store.dispatch(
      "gestionarCuposCampesena",
      this.$route.params.idCompetencia
    );
    this.$store.dispatch("obtenerSaberCompetenciaId", {
      idCompetencia: this.$route.params.idCompetencia,
      idSaber: this.$route.params.idSaber,
    });

    setTimeout(() => {
      this.skeletonLoader = false;
      console.log(this.regional)
    }, 1000);
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Registrar Cupo" : "Actualizar Cupo";
    },
    regionales() {
      console.log(this.$store.getters.obtenerRegionales)
      return this.$store.getters.obtenerRegionales;
    },
    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacion(this.regional);
    },
    saberCompetencia() {
      return this.$store.getters.obtenerSaberCompetencia;
    },

    cuposSaber() {
      return this.$store.getters.obtenerCuposCampesena(
        this.$route.params.idSaber
      );
    },
    competencias() {
      return this.$store.getters.obtenerCompetenciaCampesena;
    },

    cupo() {
      return this.$store.getters.obtenerCupoCampesena;
    },

    cuposRegistrados() {
      return this.cuposSaber.reduce((suma, cupo) => {
        return suma + cupo.numero_participantes;
      }, 0);
    },

    cuposDisponibles() {
      return this.saberCompetencia.numero_participantes - this.cuposRegistrados;
    },

    cantidadGrupos() {
      if (this.modalidadId == 2) {
        if (this.numeroParticipantes % 2 == 0) {
          return this.numeroParticipantes / this.modalidadId;
        }
        return 0;
      }

      return this.numeroParticipantes;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    open() {
      this.competencia = this.saberCompetencia.competencia;
      this.saber = this.saberCompetencia.saber;
      this.modalidad = this.saberCompetencia.modalidad;
      this.modalidadId = this.saberCompetencia.modalidad_id;
      this.cupoDisponible = this.cuposDisponibles;
      this.saberId = this.saberCompetencia.saber_id;
      this.dialog = true;
    },

    close() {
      this.$refs.form.reset();
      this.dialog = false;
      this.editedIndex = -1;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    registrar() {
      if (this.$refs.form.validate()) {
        const cupo_saber = {
          competencia_id: this.$route.params.idCompetencia,
          saber_id: this.$route.params.idSaber,
          centro_formacion_id: this.centroFormacion,
          numero_participantes: this.numeroParticipantes,
        };

        this.loadingForm = true;

        this.$store
          .dispatch("registrarCupoCampesena", cupo_saber)
          .then((response) => {
            if (response.status == "success") {
              this.close();
              this.loadingForm = false;

              const message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              this.skeletonLoader = true;

              this.$store.dispatch(
                "gestionarCuposCampesena",
                this.$route.params.idCompetencia
              );
              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 2000);
            } else {
              this.loadingForm = false;
              this.alertType = "error--text";
              this.alertTitle = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }

              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
      }
    },

    editarCupo(id) {
      this.editedIndex = 1;
      this.cupoId = id;

      this.competencia = this.saberCompetencia.competencia;
      this.saber = this.saberCompetencia.saber;
      this.modalidad = this.saberCompetencia.modalidad;
      this.modalidadId = this.saberCompetencia.modalidad_id;
      this.cupoDisponible = this.cuposDisponibles;
      this.saberId = this.saberCompetencia.saber_id;
      this.$store.dispatch("obtenerCupoCampesenaId", id);
      setTimeout(() => {
        const detalles = this.cupo;
        this.regional = detalles.regional_id;
        this.centroFormacion = detalles.centro_formacion_id;
        this.numeroParticipantes = detalles.numero_participantes;
      }, 1000);

      this.dialog = true;
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const cupo = {
          competencia_id: this.$route.params.idCompetencia,
          saber_id: this.saberId,
          numero_participantes: this.numeroParticipantes,
        };

        this.loadingForm = true;

        this.$store
          .dispatch("actualizarCupoCampesena", {
            cupoId: this.cupoId,
            categoriaId: this.$route.params.idSaber,
            cupo: cupo,
          })
          .then((response) => {
            if (response.status == "success") {
              this.close();
              this.loadingForm = false;

              const message = response.message.split(",");
              this.alertType = "success--text";
              this.alertTitle = message[0];
              this.alertMessage = message[1];
              this.alert = true;

              this.skeletonLoader = true;

              this.$store.dispatch(
                "gestionarCuposCampesena",
                this.$route.params.idCompetencia
              );
              setTimeout(() => {
                this.alert = false;
                this.skeletonLoader = false;
              }, 2000);
            } else {
              this.loadingForm = false;
              this.alertType = "error--text";
              this.alertTitle = "Error";

              for (const error in response.message) {
                this.alertMessage = response.message[error][0];
              }

              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 3000);
            }
          })
          .catch(() => {});
      }
    },

    DialogEliminarCupo(id) {
      this.cupoId = id;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.eliminarCupo(this.cupoId);
      this.closeDelete();
    },

    eliminarCupo(cupoId) {
      this.dialogDelete = false;

      this.$store
        .dispatch("eliminarCupoCampesena", cupoId)
        .then((response) => {
          if (response.status == "success") {
            const message = response.message.split(",");
            this.alertType = "success--text";
            this.alertTitle = message[0];
            this.alertMessage = message[1];
            this.alert = true;

            this.skeletonLoader = true;
            this.$store.dispatch(
              "gestionarCuposCampesena",
              this.$route.params.idCompetencia
            );
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 2000);
          } else {
            this.loadingForm = false;
            this.alertType = "error--text";
            this.alertTitle = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0];
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
        })
        .catch(() => {});
    },

    regresar() {
      this.$router.back();
    },
  },
};
</script>
